import { IGetItemFolhaPagamentoUseCase } from "../../../presentation/useCases/read/get_item_folha_pagamento_use_case";
import { ItemFolhaPagamentoDetalhe } from "../../models/item_folha_pagamento_detalhe";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetItemFolhaPagamentoUseCase
 */

export class GetItemFolhaPagamentoUseCase implements IGetItemFolhaPagamentoUseCase {
  constructor(private readonly repository: IRhRepository) { }

  async getItemFolhaPagamento(
    idItemFolhaPagamento: number,
  ): Promise<ItemFolhaPagamentoDetalhe> {
    return await this.repository.getItemFolhaPagamento(idItemFolhaPagamento);
  }
}
